import { useState } from "react";

export default function InquireForm() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      await fetch("https://readdy.ai/api/form/d71ui9bk1jkj467r5nmg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <section id="inquire" className="bg-pk-charcoal py-24">
      <div className="max-w-screen-xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <span className="font-sans text-xs tracking-widest3 uppercase text-pk-gold">
              Get In Touch
            </span>
            <h2 className="font-display text-5xl md:text-6xl font-medium text-white mt-4 leading-tight">
              Let&apos;s Begin Your Story
            </h2>
            <p className="font-sans text-sm text-pk-cream/60 mt-5 leading-7 max-w-md">
              Ready to create something extraordinary? Reach out and Stephanie will personally respond within 24–48 hours to discuss your vision.
            </p>
            <div className="mt-10 space-y-4">
              <a href="tel:2108154698" className="flex items-center gap-4 group cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center bg-pk-gold/10 rounded-sm group-hover:bg-pk-gold transition-colors duration-300">
                  <i className="ri-phone-line text-pk-gold text-lg group-hover:text-white transition-colors duration-300" />
                </div>
                <span className="font-sans text-sm text-pk-cream/70 group-hover:text-pk-gold transition-colors duration-300">210-815-4698</span>
              </a>
              <a href="mailto:stephanie@precious-keepsakes.com" className="flex items-center gap-4 group cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center bg-pk-gold/10 rounded-sm group-hover:bg-pk-gold transition-colors duration-300">
                  <i className="ri-mail-line text-pk-gold text-lg group-hover:text-white transition-colors duration-300" />
                </div>
                <span className="font-sans text-sm text-pk-cream/70 group-hover:text-pk-gold transition-colors duration-300 break-all">stephanie@precious-keepsakes.com</span>
              </a>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-pk-gold/10 rounded-sm">
                  <i className="ri-map-pin-line text-pk-gold text-lg" />
                </div>
                <span className="font-sans text-sm text-pk-cream/70">San Antonio, Texas</span>
              </div>
            </div>
          </div>

          {/* Form */}
          <div>
            {submitted ? (
              <div className="bg-pk-gold/10 border border-pk-gold/30 rounded-sm p-12 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-pk-gold rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-white text-xl" />
                </div>
                <h3 className="font-display text-3xl text-white mb-3">Thank You!</h3>
                <p className="font-sans text-sm text-pk-cream/60 leading-7">
                  Stephanie will be in touch within 24–48 hours. She looks forward to learning more about your vision.
                </p>
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="space-y-5"
              >
                <div className="grid grid-cols-2 gap-5">
                  <div>
                    <label className="font-sans text-xs tracking-widest uppercase text-pk-cream/50 block mb-2">Name *</label>
                    <input
                      type="text"
                      name="Name"
                      required
                      className="w-full bg-white/5 border border-white/10 text-white text-sm font-sans px-4 py-3 rounded-sm focus:outline-none focus:border-pk-gold transition-colors"
                      placeholder="Your name"
                    />
                  </div>
                  <div>
                    <label className="font-sans text-xs tracking-widest uppercase text-pk-cream/50 block mb-2">Phone</label>
                    <input
                      type="tel"
                      name="PHONE"
                      className="w-full bg-white/5 border border-white/10 text-white text-sm font-sans px-4 py-3 rounded-sm focus:outline-none focus:border-pk-gold transition-colors"
                      placeholder="Your phone"
                    />
                  </div>
                </div>
                <div>
                  <label className="font-sans text-xs tracking-widest uppercase text-pk-cream/50 block mb-2">Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full bg-white/5 border border-white/10 text-white text-sm font-sans px-4 py-3 rounded-sm focus:outline-none focus:border-pk-gold transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
                <div>
                  <label className="font-sans text-xs tracking-widest uppercase text-pk-cream/50 block mb-2">Session Type</label>
                  <select
                    name="Session Type"
                    className="w-full bg-white/5 border border-white/10 text-white text-sm font-sans px-4 py-3 rounded-sm focus:outline-none focus:border-pk-gold transition-colors cursor-pointer"
                  >
                    <option value="" className="text-pk-charcoal">Select a session type</option>
                    <option value="Newborn" className="text-pk-charcoal">Newborn Photography</option>
                    <option value="Wedding" className="text-pk-charcoal">Luxury Wedding</option>
                    <option value="Maternity" className="text-pk-charcoal">Maternity</option>
                    <option value="Senior" className="text-pk-charcoal">Senior Portraits</option>
                    <option value="Quinceanera" className="text-pk-charcoal">Quinceañera / Sweet 16</option>
                    <option value="Family" className="text-pk-charcoal">Family / Milestone</option>
                  </select>
                </div>
                <div>
                  <label className="font-sans text-xs tracking-widest uppercase text-pk-cream/50 block mb-2">Message *</label>
                  <textarea
                    name="Message"
                    required
                    rows={4}
                    maxLength={500}
                    className="w-full bg-white/5 border border-white/10 text-white text-sm font-sans px-4 py-3 rounded-sm focus:outline-none focus:border-pk-gold transition-colors resize-none"
                    placeholder="Tell Stephanie about your vision, session date, or any questions you have..."
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-pk-gold text-white font-sans text-sm tracking-widest uppercase py-4 rounded-sm hover:bg-white hover:text-pk-charcoal transition-colors duration-300 cursor-pointer whitespace-nowrap"
                >
                  Send My Inquiry
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}